module.exports = __webpack_public_path__ + "img/Maintanence.b8b46d3c.jpg";